// Search bar open & close
var searchIcon = $("#wz-search-icon")[0];
$(searchIcon).click(function () {
  $(this).parent().parent().toggleClass("wz-search-bar-opened");
  setTimeout(() => {
    var input = $(".wizzy-search-input")[0];
    $(input).focus();
    $(input).click();
  }, 0);
});

$(document).ready(function(){
  var items = [];
  $('body').on('click','[data-addone-add]', function(){
    var vid = $(this).attr('data-vid');    
    if($(this).hasClass('added')){
      items = items.filter(item => item.id !== vid);
      $(this).removeClass('added'); 
    }else{      
      items.push({
        id: vid,
        quantity: 1        
      });
      $(this).addClass('added'); 
    }    
  });
  $('body').on('click','[data-init-alltocart]', function(){
    console.log(items);  
    var _this = this;
    console.log(items.length);
    if(items.length > 0){
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      var data = {items};
      data['sections'] = sectionsToBundle.join(",");
      
      fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(async function(responseJson) {
        $('.accessory-popup,.popup-overlay').removeClass('active');
        $('body').removeClass('lock');
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        const cartContent = await fetch(`${Shopify.routes.root}cart.js`).then(res => res.json());
        cartContent["sections"] = responseJson["sections"];
        console.log(cartContent);
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
        items = [];
        $(_this).closest('.accessory-popup').find('[data-addone-add]').removeClass('added');
      });  
    }else{
      $('.accessory-popup,.popup-overlay').removeClass('active');
      $('body').removeClass('lock');
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    }
    
  });

  $('body').on('click','.accessory-popup .popup-close', function(){
    $('.accessory-popup,.popup-overlay').removeClass('active');
    $('body').removeClass('lock');
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:open"));
  });

  

  if($('[createCustomerForm]').length > 0){
    //set cookie
    function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }
  
   $('body').on('submit','[createCustomerForm]', function (e) {
      e.preventDefault(); // Prevent form submission
       var _this = $(this);
       // _this.find('.banner--success,.banner--error').hide();
     
      const phone = '91'+_this.find('#phone').val().replace(/\s+/g, '');
      const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format
  console.log(phone);
      // Basic Validation
      if (!phoneRegex.test(phone)) {
        _this.closest('.miraggio-popup').find('.message-banner').addClass('banner--error').removeClass('banner--success').html("Please enter a valid 10 digit number without any space.");
        _this.closest('.miraggio-popup').find('.message-banner').show();  
        return;
      }
  
      $.ajax({
        url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
        method: "POST",
        contentType:"application/json",
        headers: {
          "Authorization": "970614a6802448fd87feb315a2fc121d"
        },
        data: JSON.stringify({
          phone: phone,
          tag: 'Pet Personalize'
        }),
        success: function (response) {
          console.log(response);
          if(response.status == 1){
            // _this.closest('.miraggio-popup').find('.message-banner').addClass('banner--success').removeClass('banner--error').html(response.message);
            // _this.closest('.miraggio-popup').find('.message-banner').show();  
             _this.closest('.miraggio-popup').addClass('submitted');
            setCookie('petpopup_submit',true,3000);
          }else{
            _this.closest('.miraggio-popup').find('.message-banner').addClass('banner--error').removeClass('banner--success').html(response.message);
            _this.closest('.miraggio-popup').find('.message-banner').show();  
          }
          
        },
        error: function (xhr, status, error) {
          console.log(xhr, status, error);
          _this.closest('.miraggio-popup').find('.message-banner').addClass('banner--error').removeClass('banner--success').html(response.message);
          _this.closest('.miraggio-popup').find('.message-banner').show();  
        }
      });
                   
    }); 
  }  
  
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

document.addEventListener('DOMContentLoaded', function () {
  const hasSubmitted = getCookie('petpopup_submit') === 'true';
  const alreadyShown = sessionStorage.getItem('miraggioPopupShown');

  if (!hasSubmitted && !alreadyShown) {
    setTimeout(() => {
      document.getElementById('miraggioPopup').style.display = 'flex';
      sessionStorage.setItem('miraggioPopupShown', 'true');
    }, 4500); // 4.5 seconds
  }

  if(document.getElementById('closePopupBtn')){
    document.getElementById('closePopupBtn').addEventListener('click', function () {
      document.getElementById('miraggioPopup').style.display = 'none';
    });
  }
  
});

window.onWizzyScriptLoaded = function () {
  $("body").on("focus", ".wizzy-search-input", function () {
    $("body").addClass("wz-wrapper-opened");
  });
  $("body").on("blur", ".wizzy-search-input", function () {
    $("body").removeClass("wz-wrapper-opened");
  });

  
  // Replacing default template
  replaceTemplate("wizzy-search-results-product");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      window.wizzyConfig.search.configs.general.minQueryLength = 1;
      window.wizzyConfig.common.isLazyInit = true;
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        if (product.sellingPrice) {
          try {
            var offerPrice = parseFloat(product.sellingPrice.replace(/,/g, ""));
          } catch (e) {
            console.log(e);
          }
          var offerPrice_ = offerPrice - (offerPrice * 10) / 100;
          product.offerPrice__ = Math.ceil(
            offerPrice_ - (offerPrice_ * 5) / 100
          );
        }
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log(data.filters);
      data.filters.inStock = ["true","false"];
      // data.filters.showOOSProductsInOrder = "true";
      data.filters.attributeFacetValuesLimit = 100;
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.minQueryLength = 1;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // Check if the <body> element exists
      var bodyElement = document.querySelector('body');
      if (bodyElement) {
          bodyElement.classList.add('wizzy-cache-render');
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 100;
      console.log(data,"BEFORE_SEARCH_EXECUTED");
      data.minQueryLength = 1;

      const searchCloseButton = window.document.querySelector("#predictive-search-form  button");
      if(searchCloseButton){
        searchCloseButton.click();
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $(".st-search-bar.custom-desktop").hide();
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

if(document.getElementById('pet-photo')){
  const fileInput = document.getElementById('pet-photo');
  const filePreview = document.getElementById('file-preview');
  const fileName = document.getElementById('file-name');
  const disableatcbutton = document.getElementById('disable_button');
  const mainatcbutton = document.getElementById('atc-button-main');
  const successele = document.getElementById('upload_success_msg');
  // const fileSize = document.getElementById('file-size');
  const uploadPlaceholder = document.getElementById('upload-placeholder');
  const removeBtn = document.getElementById('remove-file');
  
  fileInput.addEventListener('change', function () {
    successele.style.display = 'none';
    const file = this.files[0];
    if (file) {
      fileName.textContent = file.name;
      // fileSize.textContent = `${Math.round(file.size / 1024)} KB`;
      filePreview.style.display = 'flex';
      uploadPlaceholder.style.display = 'none';
      this.setAttribute('name','properties[Art Image]');
      successele.style.display = 'block';
      disableatcbutton.style.display = 'none';
      mainatcbutton.style.display = 'block';
    }else{
      this.removeAttribute('name');  
    }
  });
  
  removeBtn.addEventListener('click', function () {
    fileInput.value = '';
    filePreview.style.display = 'none';
    uploadPlaceholder.style.display = 'block';
    successele.style.display = 'none';
    fileInput.removeAttribute('name');  
    disableatcbutton.style.display = 'block';
    mainatcbutton.style.display = 'none';
  });
}

// if(document.getElementById('art-photo')){  
//   document.getElementById('art-photo').addEventListener('change', function (e) {
//     const file = e.target.files[0];
//     const fileName = e.target.files.length > 0 ? e.target.files[0].name : "No file chosen";
//     document.getElementById('file-name').textContent = fileName;
//     if (!file){
//       this.removeAttribute('name');  
//     }else{
//       this.setAttribute('name','properties[Art Image]');
//     }
//   });
// }


/////// Mutation Observer

const targetNode = window.document.querySelector(".html-element-padding");

const observerOptions = {
  attributes: true,    // Observe attribute changes
  attributeFilter: ['class'], // Only watch changes to the "class" attribute
};

const mutationCallback = (mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const isWrapperOpened = targetNode.classList.contains('lock');
      
      const headerElement = document.querySelector('.header.color-scheme');
      
      if (headerElement) {
        if (isWrapperOpened) {
          if (!headerElement.classList.contains('is-solid')) {
            headerElement.classList.add('is-solid');
          }
        } else {
          if (headerElement.classList.contains('is-solid')) {
            headerElement.classList.remove('is-solid');
          }
        }
      }
    }
  });
};

const observer = new MutationObserver(mutationCallback);

observer.observe(targetNode, observerOptions);
